<p><strong>You are not logged in.</strong></p>
<p>Please login in again and verify you have 3rd-party cookies enabled in your web browser.</p>
<p>Read more about changing your browser's cookies settings for
  <ng-container [ngSwitch]="deviceService.browser">
    <a *ngSwitchCase="'Chrome'" href="https://support.google.com/chrome/answer/95647" target="_blank">Google Chrome</a>
    <a *ngSwitchCase="'Safari'"
      href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/12.0/mac/10.14"
      target="_blank">Apple Safari</a>
    <a *ngSwitchCase="'Firefox'"
      href="https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them" target="_blank">Mozilla
      Firefox</a>
    <a *ngSwitchCase="'MS-Edge'" href="https://www.google.com/search?q=microsoft+edge+enable+third+party+cookies"
      target="_blank">Microsoft Edge</a>
    <a *ngSwitchCase="'IE'" href="https://www.google.com/search?q=internet+explorer+enable+third+party+cookies"
      target="_blank">Internet Explorer</a>
    <a *ngSwitchDefault href="https://www.google.com/search?q=enable+third+party+cookies" target="_blank">your web
      browser</a>
  </ng-container>.
</p>